import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { FirmwareProvider } from "./context/FirmwareContext";
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import Home from "./pages/home/Home";
import Brands from "./pages/brands/Brands";
import Models from "./pages/models/Models";
import Firmware from "./components/firmware/Firmware";
import Success from "./pages/success/Success";
import Failure from "./pages/failure/Failure";
import About from "./pages/about/About";
import Explanation from "./pages/explanation/Explanation";

function App() {
  
  return (
    <FirmwareProvider>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={ <Home /> } />
          <Route path="/brands" element={ <Brands /> } />
          <Route path="/brands/:brand" element={ <Models /> } />
          <Route path="/brands/:brand/:model/:instalation" element={ <Firmware /> } />
          <Route path="/success" element={ <Success /> } />
          <Route path="/failure" element={ <Failure /> } />
          <Route path="/about" element={ <About /> } />
          <Route path="/explanation" element={ <Explanation /> } />
        </Routes>
        <Footer />
      </Router>
    </FirmwareProvider>
  );
}

export default App;